import { render, staticRenderFns } from "./authStatus.vue?vue&type=template&id=8c820c58&scoped=true"
import script from "./authStatus.vue?vue&type=script&lang=js"
export * from "./authStatus.vue?vue&type=script&lang=js"
import style0 from "./authStatus.vue?vue&type=style&index=0&id=8c820c58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c820c58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c820c58')) {
      api.createRecord('8c820c58', component.options)
    } else {
      api.reload('8c820c58', component.options)
    }
    module.hot.accept("./authStatus.vue?vue&type=template&id=8c820c58&scoped=true", function () {
      api.rerender('8c820c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/approve/components/authStatus.vue"
export default component.exports